const convertBase64ToArrayBuffer = (value: string): ArrayBuffer => {
  const binaryString = atob(value);
  const bytes = new Uint8Array(binaryString.length);

  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  return bytes.buffer;
};

export const downloadFile = (base64Data: string, name: string, type: string): void => {
  const arrayBuffer = convertBase64ToArrayBuffer(base64Data);
  const blob = new Blob([arrayBuffer], { type });

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");

  a.href = url;
  a.download = name;
  a.click();

  URL.revokeObjectURL(url);
};
